// OAuth Callback Handler for CCB V2 API
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authorizeCCBV2 } from '../firebase/functionsService';
import { readOnlyProps } from '../utils/viewAs';

const OAuthCallback = () => {
  const ro = readOnlyProps(); // disable write controls while viewing as someone
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing OAuth callback...');
  const [code, setCode] = useState(null);

  useEffect(() => {
    const authCode = searchParams.get('code');
    const error = searchParams.get('error');

    if (error) {
      setStatus('error');
      setMessage(`OAuth Error: ${error}`);
      return;
    }

    if (authCode) {
      setCode(authCode);
      setStatus('code_received');
      setMessage('Authorization code received! Click below to complete setup.');
    } else {
      setStatus('error');
      setMessage('No authorization code found in URL');
    }
  }, [searchParams]);

  const handleAuthorize = async () => {
    if (!code) return;

    setStatus('authorizing');
    setMessage('Completing OAuth authorization...');

    try {
      const result = await authorizeCCBV2({
        code: code,
        redirectUri: 'https://btagms.brooklyntab.org'
      });

      setStatus('success');
      setMessage('CCB V2 OAuth authorization completed successfully! You can now close this page.');
      console.log('OAuth result:', result);
    } catch (error) {
      setStatus('error');
      setMessage(`Authorization failed: ${error.message}`);
      console.error('OAuth error:', error);
    }
  };

  return (
    <div style={{
      padding: '40px',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <h1>CCB V2 OAuth Setup</h1>

      <div style={{
        padding: '20px',
        margin: '20px 0',
        borderRadius: '8px',
        backgroundColor: status === 'success' ? '#d4edda' :
                        status === 'error' ? '#f8d7da' :
                        '#fff3cd',
        color: status === 'success' ? '#155724' :
               status === 'error' ? '#721c24' :
               '#856404'
      }}>
        <p>{message}</p>
      </div>

      {code && (
        <div style={{
          padding: '15px',
          backgroundColor: '#f5f5f5',
          borderRadius: '4px',
          marginBottom: '20px',
          wordBreak: 'break-all'
        }}>
          <strong>Code:</strong> {code.substring(0, 20)}...
        </div>
      )}

      {status === 'code_received' && (
        <button
          onClick={handleAuthorize}
          disabled={ro.disabled}
          title={ro.title}
          style={{
            padding: '15px 30px',
            fontSize: '16px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Complete Authorization
        </button>
      )}

      {status === 'authorizing' && (
        <div>Processing...</div>
      )}

      {status === 'success' && (
        <p>You can now create guest profiles with images uploaded directly to CCB!</p>
      )}
    </div>
  );
};

export default OAuthCallback;
